import { ApiError } from "../../shared/errors/ApiError";
import { getTokenData } from "./getTokenData";

export async function getAuthHeaders() {
  const { token, client_id } = await getTokenData();

  if (!token) {
    throw new ApiError({
      error: "auth_error",
      message: "Token de autenticação não encontrado",
    });
  }

  if (!client_id) {
    throw new ApiError({
      error: "auth_error",
      message: "ID do cliente não encontrado",
    });
  }

  return {
    Authorization: token,
    Client_ID: client_id,
  };
}
